import styled from "styled-components";

import { Input } from "ds/Input";

export const SearchInputRoot = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  svg:last-child {
    right: 8px;
    position: absolute;
    cursor: pointer;
  }
`;

export const SearchInput = styled(Input)`
  height: 32px;
`;
